import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.99996 0.666016C4.39996 0.666016 0.666626 4.39935 0.666626 8.99935C0.666626 13.5993 4.39996 17.3327 8.99996 17.3327C13.6 17.3327 17.3333 13.5993 17.3333 8.99935C17.3333 4.39935 13.6 0.666016 8.99996 0.666016ZM8.99996 15.666C5.31663 15.666 2.33329 12.6827 2.33329 8.99935C2.33329 5.31602 5.31663 2.33268 8.99996 2.33268C12.6833 2.33268 15.6666 5.31602 15.6666 8.99935C15.6666 12.6827 12.6833 15.666 8.99996 15.666Z",
      fill: "currentColor",
      "fill-opacity": "0.87"
    }, null, -1)
  ])))
}
export default { render: render }